export default __webpack_public_path__ + "static/media/moon-dark.2275a755.svg";